export interface ILookup {
    id: number;
    statusId?: number;
    name: string;
}

export interface IProductForGroups {
    id: number;
    productName: string;
    brand: string;
    unit: number;
    sku: string;
    categoryName: string;
    categoryId: number;
    subCategory: string;
    subCategoryId: number;
    leaderSku: string|null;
}

export interface IDetailsTable {
    sku: string;
    productName: string;
    isLeader: boolean;
    capacity: number|null;
    unit: number|null; // pack qty
    retailUnits: number|null; // unit
    delta: string|null;
}

export enum PricingManagerStatus {
    AwaitingResponse = 1, /* Pendeng */
    Rejected,
    Approved,
    NoActionRequired,
    HasRecommendation = -1, /* Virtual state matching 1,3,4. */
    MixedStates = -2        /* Virtual state to represent a status on a set of recommendations with different states. */
}

export enum ProductGroupType {
    Standard = "Standard",
    BPBV = "BPBV",
}

export enum PriceDeltaType {
    EUR = "EUR",
    Percentage = "Percentage",
}

export enum CountryCode {
    poland = "PL" //"LU"
}

export enum DataSourceOption {
    PIM = "PIM",
    RSTS = "RSTS",
    Calculated = "Calculated"
}

export enum NotificationType {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
    CONCURRENCY = "CONCURRENCY"
}

export type NotificationMessageType = keyof typeof NotificationType;
